export const CreateReturnDisabledReason = {
  IsUnshipped: 'IsUnshipped',
  HasPendingReturn: 'HasPendingReturn',
};
